import { render, staticRenderFns } from "./author.vue?vue&type=template&id=42f75c12&scoped=true&"
import script from "./author.vue?vue&type=script&lang=js&"
export * from "./author.vue?vue&type=script&lang=js&"
import style0 from "./author.vue?vue&type=style&index=0&id=42f75c12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f75c12",
  null
  
)

export default component.exports